<script setup>
  import { computed, onMounted, reactive, toRefs } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute, useRouter } from 'vue-router'

  import { getEnterpriseJoinList } from '@/http/api'

  const route = useRoute()
  const router = useRouter()

  const store = useStore()
  const enterpriseGlobalObj = computed(
    () => store.state.comm.enterpriseGlobalObj
  )
  const enterpriseList = computed(() => store.state.comm.enterpriseList)

  const state = reactive({
    isOpen: false,
  })

  const getEnterpriseList = () => {
    store.dispatch('comm/getEnterpriseJoinListFunc').then((list) => {
      if (list.length === 0) {
        store.dispatch('user/checkToken').then((res) => {
          if (res.accountType === 'enterprise') {
            window.location.href = '/go/pe_pc_login/pe?redirect=401'
          }
        })
      } else {
        let query = {
          ...route.query,
        }
        query.enterpriseId = store.state.comm.enterpriseGlobalId
        sessionStorage.setItem('enterpriseId', query.enterpriseId)
        store.dispatch('comm/getUserLevelPrivilege')
        router.push({
          path: route.path,
          query: query,
        })
      }
    })
  }

  // 显示与隐藏
  const visibleChange = (val) => {
    state.isOpen = val
    // if (val) {
    //   getEnterpriseList()
    // }
  }

  // 切换企业
  const chooseEnterpriseFunc = (enterpriseId, isRe) => {
    state.isOpen = false
    let query = {
      ...route.query,
    }
    query.enterpriseId = enterpriseId
    sessionStorage.setItem('enterpriseId', enterpriseId)
    router.push({
      path: route.path,
      query: query,
    })
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }

  //tw公共引擎项目是做强拦截，别的项目转为个人版？
  onMounted(() => {
    getEnterpriseJoinList({ skipValidate: true }).then(({ data }) => {
      const list = data.data || []
      let queryEnterpriseId =
        route.query.enterpriseId || store.state.comm.enterpriseGlobalId
      if (queryEnterpriseId) {
        let enterpriseInfo = list.find((item) => {
          return item.id == queryEnterpriseId
        })

        if (enterpriseInfo) {
          enterpriseInfo.list = [...list]
          store.dispatch('comm/setEnterpriseInfo', enterpriseInfo)
          store.dispatch('comm/getUserLevelPrivilege')
          store.dispatch('comm/getEnterpriseSettingsFunc')
        } else {
          window.location.href = `/go/pe_pc_login/selectEnterprise?fromPage=${location.href}`
        }
      } else {
        getEnterpriseList()
      }
    })
  })

  const { isOpen } = toRefs(state)

  // watch(() => route.path, () => {
  //   router.replace({
  //     path: route.path,
  //     query: {
  //       ...route.query,
  //       enterpriseId: state.enterpriseId,
  //     },
  //   })
  // })
</script>

<template>
  <a-dropdown
    :trigger="['click']"
    @visibleChange="visibleChange"
    v-if="enterpriseList.length > 0"
    :disabled="route.fullPath.includes('/subData')"
  >
    <a
      class="team-top-box flex-align-center"
      @click="(e) => e.preventDefault()"
    >
      <div class="margin-r-5">
        <img
          :src="enterpriseGlobalObj.logo"
          alt=""
          v-if="enterpriseGlobalObj.logo"
          width="28"
          height="28"
        />
      </div>
      <div
        class="font-size-14 font-style text-ellipsis-1 font-weight-600"
        :title="enterpriseGlobalObj.name || ''"
      >
        {{ enterpriseGlobalObj.name || '&nbsp;' }}
      </div>
      <svg
        aria-hidden="true"
        class="drop-icon"
        :class="isOpen && 'icon-transform'"
        v-if="!route.fullPath.includes('/subData')"
      >
        <use xlink:href="#icon-xiabiao"></use>
      </svg>
    </a>
    <template #overlay>
      <div class="team-container">
        <div class="team-menu">
          <div
            class="team-menu-item flex-align-center"
            :title="item.name"
            :key="key"
            v-for="(item, key) in enterpriseList"
            @click="chooseEnterpriseFunc(item.id)"
            :class="
              enterpriseGlobalObj.id == item.id
                ? 'active-menu'
                : 'not-active-menu'
            "
          >
            <div>
              <img :src="item.logo" width="24" height="24" v-if="item.logo" />
            </div>
            <span class="padding-l-10 text-ellipsis-1 width-200">
              {{ item.name }}
            </span>
            <div class="width-50 margin-t-2 flex-align-center justify-end">
              <svg
                aria-hidden="true"
                class="drop-icon checked-icon"
                v-if="enterpriseGlobalObj.id == item.id"
              >
                <use xlink:href="#icon-xuanzhong"></use>
              </svg>
              <div class="color-00c6f3 font-size-14 checked-btn">切换</div>
            </div>
            <div class="width-70 text-right">
              <img
                v-if="item.vipLevelCode == 'free' || !item.vipLevelCode"
                src="../../../images/home/v0.png"
                width="16"
              />
              <img
                v-else-if="item.vipLevelCode == 'startup'"
                src="../../../images/home/v1.png"
                width="16"
              />
              <img
                v-else-if="item.vipLevelCode == 'enterprise'"
                src="../../../images/home/v2.png"
                width="16"
              />
              <img
                v-else-if="item.vipLevelCode == 'ultimate'"
                src="../../../images/home/v3.png"
                width="16"
              />
              <img
                v-else-if="item.vipLevelCode == 'ultimate-plus'"
                src="../../../images/home/vip.png"
                width="16"
              />
              <span class="margin-l-2 color-bbb font-size-12">
                {{ item.vipLevelName || '免费版' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </a-dropdown>
</template>

<style lang="scss" scoped>
  .team-top-box {
    margin-left: 10px;
    height: 40px;
    min-width: 168px;
    max-width: 168px;
    padding: 0 10px;
    background: #fff;
    border-radius: 6px;
    .font-style {
      color: #333;
      font-weight: 600;
      max-width: 200px;
      margin-right: 10px;
    }
    .icon-transform {
      transform: rotate(180deg);
      transition: all 0.3s;
    }

    a {
      &:hover {
        .xb-icon {
          color: #333;
        }
      }
    }
    &:hover {
      .xb-icon {
        color: #333;
      }
    }
  }
  .team-container {
    position: relative;
    padding-bottom: 10px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 6px;
    box-shadow: 0px 12px 14px 0px rgba(0, 0, 0, 0.1);
  }
  .team-menu {
    padding: 20px 20px 0;
    max-height: 300px;
    overflow-y: auto;
    &::-webkit-input-placeholder {
      font-size: 14px;
      color: #818385;
    }
    &::-webkit-scrollbar {
      width: 7px;
      background-color: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
      width: 7px;
    }
  }
  .team-menu-item {
    height: 40px;
    padding: 0 8px;
    margin-bottom: 4px;
    &:hover {
      background-color: #f3f4f6;
      border-radius: 6px;
      cursor: pointer;
      .checked-btn {
        display: block;
      }
      .checked-icon {
        display: none;
      }
    }
    .checked-btn {
      display: none;
    }
  }
  .team-manage-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    background-color: #fff;
    border-top: 1px solid #f2f3f5;
    cursor: pointer;
  }
  .width-50 {
    width: 50px;
  }
  .width-70 {
    width: 70px;
  }
  .width-200 {
    width: 200px;
  }
</style>
